import React from "react";

export default function FeatureSection({
  id,
  subheading,
  heading,
  description,
  imageSrc,
  textOnLeft = true,
}) {
  return (
    <section id={id} className="max-w-screen-xl mx-auto py-10 md:py-12 px-6">
      <div
        className={`flex flex-col md:flex-row items-center justify-between gap-12 ${
          textOnLeft ? "" : "md:flex-row-reverse"
        }`}
      >
        {/* Image */}
        <div className="md:w-6/12 flex-shrink-0">
          <img src={imageSrc} alt="" className="rounded w-full max-w-lg mx-auto" />
        </div>

        {/* Text */}
        <div className="md:w-6/12 lg:py-8 text-center md:text-left">
          <h2 className="font-black text-3xl sm:text-4xl lg:text-5xl leading-tight">{heading}</h2>
          {subheading && (
            <p className="mt-2 text-primary-500 font-bold text-sm uppercase tracking-widest">{subheading}</p>
          )}
          <p className="mt-4 text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100">
            {description}
          </p>
          <a
            href="#contact"
            className="inline-block mt-8 px-8 py-3 bg-primary-500 text-white text-sm font-bold rounded hover:bg-primary-700 transition"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
